/** Data de hoje no fuso local (YYYY-MM-DD). */
export function todayIsoDateLocal(): string {
  const now = new Date();

  return [
    now.getFullYear(),
    String(now.getMonth() + 1).padStart(2, '0'),
    String(now.getDate()).padStart(2, '0'),
  ].join('-');
}

export function clampIsoDateToMax(isoDate: string, maxIso: string): string {
  return isoDate > maxIso ? maxIso : isoDate;
}

/** Formata YYYY-MM-DD para DD/MM/AAAA. */
export function formatIsoDateBr(isoDate: string): string {
  const [year, month, day] = isoDate.slice(0, 10).split('-');

  if (!year || !month || !day) {
    return isoDate;
  }

  return `${day}/${month}/${year}`;
}
